<template>
  <div class="cancel">
    <div class="top">
      <headline-view v-bind:title="title" />
    </div>
    <div class="middle">
      <span style="color:red">Note:</span>
      <br/>
      <span>Cancelling the subscription does not constitute a refund. Your subscription will not be renewed after the current term ends, and no further payments will be charged. Access to the subscription will end once the current term expires. Please note that no refunds are issued by cancelling the subscription.</span>
    </div>
    <div class="bottom">
      <button
        v-bind:disabled="this.$store.state.subscription.active == 0"
        v-on:click="cancelSubscription()"
        class="cancel-button"
      >
        cancel subscription
      </button>
    </div>
  </div>
</template>

<script>
import HeadlineView from "@/components/Checkout/Headline.vue";

export default {
  name: "cancel-view",
  data() {
    return {
      title: "Cancel Subscription",
    };
  },
  components: {
    "headline-view": HeadlineView,
  },
  mounted() {},
  computed: {},
  methods: {
    async cancelSubscription() {
      if (confirm("Are you sure you want to cancel your subscription?")) {
        await this.$store.dispatch("cancelSubscription");
        await this.$store.dispatch("getSubscription");
      } else {
        await this.$store.dispatch("changeErrorMsg", {
          msg: "The cancellation was aborted.",
          type: "negativ",
        });
      }
    },
  },
};
</script>

<style scoped>
.cancel {
  width: 100%;
  height: 100%;
  display: flex;
  padding-top: 30px;
  flex-direction: column;
}

.top {
  display: flex;
  width: 100%;
  height: 20%;
}
.bottom {
  display: flex;
  width: 100%;
  height: 20%;
  align-items: center;
}
.middle {
  width: 100%;
  height: 20%;
  font-size: 12px;
}

.cancel-button:hover {
  background-color: #fdd86a;
}

.cancel-button {
  width: 100%;
  height: 48px;
  background-color: #ffc20f;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  border-radius: 6px;
  cursor: pointer;
  outline: none;
  border: 1px solid #ffc20f;
}
.cancel-button:disabled {
  background-color: grey;
  border: 1px solid grey;
  cursor: not-allowed;
}
</style>
